const edit = {
  fields: [
    {
      type: 'image',
      name: 'image',
      label: 'Image',
      required: true,
    },
    {
      type: 'image',
      name: 'inner_image',
      label: 'Inner Image',
      required: true,
    },
    {
      type: 'mixed',
      name: 'title',
      label: 'Title',
      required: true,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
        },
      ],
    },
    {
      type: 'mixed',
      name: 'body',
      label: 'Body',
      required: true,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
          rich: true,
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
          rich: true,
        },
      ],
    },
    {
      type: 'mixed',
      name: 'inner_body',
      label: 'Inner Body',
      required: true,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
          rich: true,
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
          rich: true,
        },
      ],
    },
  ],
  main: true,
  breadcrumb: 'Manufacturing',
  title: 'Manufacturing',
};

const data = { edit };

export default data;
